/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery"; 
import { DeliverySummaryTblCard } from "./Component/DeliverySummaryTblCard";
import { Get_Delivery_Summary } from "../../Server/ApiV2";
import { useDispatch, useSelector } from "react-redux";
import { Set_SliceDelivery_HeadObj, Set_SliceDelivery_SummaryObj, Set_SliceDelivery_SummaryObj_Init, SliceDelivery_Init } from "./SliceDelivery";
import Delivery_BreadCrumbs from "./Delivery_BreadCrumbs";
import DetailCardComp, { DetailInputDisplay } from "../../Component/Common/ReuseableComponent/DetailCardComp";

export default function DeliverySummary() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const vRdxUserCd = useSelector((state) => state.login.value);
  const vRdxDelivery= useSelector((state) => state.SliceDelivery.value.SummaryObj);
  const [sStatusData, setStatusData] = useState([
    { uid: "ENTER", name: "ENTER" },
    { uid: "POST", name: "POST" },
    // { uid: "DELIVER", name: "DELEVER" },
  ]);
  const [sSummaryDatas, setSummaryDatas] = useState([]);
   
  
  const fSummary_OnChange = (e) => {  
    dispatch(
      Set_SliceDelivery_SummaryObj({
        ...vRdxDelivery,
      [e.target.name]: e.target.value
      })
    );
  }; 


  const getDeliverySummaryData = async () => {
    const reqData = await Get_Delivery_Summary({
      UserCd:vRdxUserCd.UserID,
      Date1:moment(vRdxDelivery?.dateFrom).format("MM/DD/YYYY"),
      Date2:moment(vRdxDelivery?.dateTo).format("MM/DD/YYYY"),
      Status:vRdxDelivery?.Status  
    });
    
    if (reqData?.status === 200) {
      setSummaryDatas(reqData.data.ResultSet);
      
    }
  };


  useEffect(() => {
    getDeliverySummaryData();  
  }, []);

  
  return (
    <div className="container-fluid my-3">
    
      <div className="mb-2">
      <Delivery_BreadCrumbs />
      </div>
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center mt-4"
        >
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Status"
              xValue={vRdxDelivery?.Status}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"Status"}
              xData={sStatusData}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={vRdxDelivery?.dateFrom}
              xOnChange={(newValue) =>
                dispatch(
                  Set_SliceDelivery_SummaryObj({
                    ...vRdxDelivery,
                    dateFrom: newValue.$d,
                  })
                )
               
              }
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={vRdxDelivery?.dateTo}
              xOnChange={(newValue) => 
                dispatch(
                  Set_SliceDelivery_SummaryObj({
                    ...vRdxDelivery,
                    dateTo: newValue.$d 
                  })
                )
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>

          <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={getDeliverySummaryData}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>

        {/* <DeliverySummaryTblCard
          data={sSummaryDatas}
          onClick={(item) => {     
            console.log("item.row",item.row);       
            dispatch(
              Set_SliceDelivery_HeadObj(item.row)
            );
            navigate("/deliveryDetail");
          }}
        /> */}
   <div
              style={{
                height: vMediaQuery ? "65vh" : "72vh",
                overflowY: "auto",
                paddingTop: "18px",
              }}
              className="xs-instant-picking-detail-grid"
            >
              <Grid container spacing={1} px={1}>
                {Array.isArray(sSummaryDatas) &&
                  sSummaryDatas?.length > 0 &&
                  sSummaryDatas?.map((item, index) => (
                    <Grid item xs={12} sm={12} md={4}  key={index}>
                      <DetailCardComp
                        data={sSummaryDatas}
                        onClick={(item) => {     
            console.log("item.row",item.row);       
            dispatch(
              Set_SliceDelivery_HeadObj(item.row)
            );
            navigate("/deliveryDetail");
          }}
                        headerLabel={item.TruckName}
                        content={
                          <Grid container spacing={2}>
                            <DetailInputDisplay
                              label="VocTyp"
                              value={item.VocTyp}
                            />
                            <DetailInputDisplay
                              label="VocNo"
                              value={item.VocNo}
                            />
                            <DetailInputDisplay label="TruckId" 
                            value={item.TruckId} />

                            <DetailInputDisplay
                              label="DeliveryStatus"
                              value={item.DeliveryStatus}
                            />
                          </Grid>
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </div>

      </div>
    </div>
  );
}
